import React, { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import privateAxios from "../../utils/axiosPrivate";
import TablePagesTitle from "../../components/table-pages-title/TablePagesTitle";
import AccessPageAction from "../accessmanagment/page-action/AccessPageAction";
import { showToast } from "../../utils/utils";
import {
  commonErrMsg,
  createPricingPlan,
  editPricingPlanGrp,
  buttonName,
  alertActions,
  fieldValidation
} from "../../locales/en";
import { showToastType } from "../../utils/constants/appConstants";
import {
  getPicingPlanUpdateNameURL,
  getPicingPlanUpdateURL
} from "../../utils/constants/apiEndPoints";
import { PRICING_PLAN_WITH_PLAN_TYPE } from "../../route/paths";

export default function EditPricingPlanGroup() {
  const initialRender = useRef(true);
  const navigate = useNavigate();
  const { id } = useParams();

  const initialPricingPlan = {
    pricingPlanName: ""
  };
  const [pricingPlan, setPricingPlan] = useState(initialPricingPlan);

  const [errors, setErrors] = useState({});

  const { pricingPlanName } = pricingPlan;

  const onInputChange = (e) => {
    const { name, value } = e.target;

    setPricingPlan((prevState) => ({
      ...prevState,
      [name]: value
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: ""
    }));
  };

  const validate = () => {
    const tempErrors = {};

    if (!pricingPlanName.trim()) {
      tempErrors.pricingPlanName = fieldValidation.required;
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const loadpricingplan = useCallback(async () => {
    try {
      const response = await privateAxios.get(getPicingPlanUpdateURL(id));
      const userData = response.data.data;

      setPricingPlan({
        ...userData
      });
    } catch {
      //handle error
    }
  }, [privateAxios, id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) {
      return;
    }
    try {
      const dataToSend = {
        ...pricingPlan
      };
      const response = await privateAxios.patch(
        getPicingPlanUpdateNameURL(id),
        dataToSend
      );
      showToast(response.data.message, showToastType?.success);
      navigate(PRICING_PLAN_WITH_PLAN_TYPE);
    } catch (error) {
      const errorMessage =
        error.response?.data?.errors ||
        error.response?.data?.message ||
        commonErrMsg?.item4;

      showToast(errorMessage, showToastType?.error);
    }
  };

  const handleCancel = () => {
    setPricingPlan({
      pricingPlanName: ""
    });
    setErrors({});
    navigate(PRICING_PLAN_WITH_PLAN_TYPE);
  };

  useEffect(() => {
    if (initialRender.current) {
      loadpricingplan();
      initialRender.current = false;
    }
  }, [loadpricingplan]);

  return (
    <>
      <TablePagesTitle
        mainTitle={createPricingPlan?.mainTitle}
        content={editPricingPlanGrp?.content}
      />
      <div className="row mb-3">
        <AccessPageAction subheading={editPricingPlanGrp?.subH2} />
      </div>
      <div className="row mb-3 mx-0">
        <div className="col-md-12 sale-leade-form">
          <form>
            <div className="row mb-2">
              <div className="col-sm-4">
                <div className="input-title">
                  <label htmlFor="pricing">
                    {createPricingPlan?.pricingName}
                  </label>
                </div>
              </div>
              <div className="col-sm-8">
                <div className="input-group">
                  <input
                    type="text"
                    placeholder="Pricing plan name"
                    name="pricingPlanName"
                    value={pricingPlanName}
                    onChange={onInputChange}
                  />
                  {errors.pricingPlanName && (
                    <div className="text-danger small">
                      {errors.pricingPlanName}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-sm-8 offset-sm-4 d-flex d-sm-block justify-content-sm-start">
                <button
                  type="button"
                  className="btn btn-red me-2"
                  onClick={handleCancel}
                >
                  {alertActions?.Cancel}
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  onClick={handleSubmit}
                >
                  {buttonName?.update}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
